/* eslint-disable */
export function hasItem(sKey: string): boolean {
	try {
		if (!sKey || /^(?:expires|max-age|path|domain|secure)$/ui.test(sKey)) {
			return false;
		}

		return new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
	} catch (error) {
		return false;
	}
}

export function getItem(sKey: string): string {
	try {
		if (!sKey) {
			return "";
		}

		// https://github.com/lidessen/cookies-ts/blob/master/src/main.ts#L35
		return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
	} catch (error) {
		return "";
	}
}

export function setItem(sKey: string, sValue: string, vEnd?: string | number | Date, sPath?: string, sDomain?: string, bSecure = false): boolean {
	try {
		if (!sKey || /^(?:expires|max-age|path|domain|secure)$/ui.test(sKey)) {
			return false;
		}

		let sExpires = "";

		if (vEnd) {
			switch (vEnd.constructor) {
				case Number:
					sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : `; max-age=${vEnd}`;
					/*
					Note: Despite officially defined in RFC 6265, the use of `max-age` is not compatible with any
					version of Internet Explorer, Edge and some mobile browsers. Therefore passing a number to
					the end parameter might not work as expected. A possible solution might be to convert the the
					relative time to an absolute time. For instance, replacing the previous line with:
					*/
					/*
					sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; expires=" + (new Date(vEnd * 1e3 + Date.now())).toUTCString();
					*/
					break;

				case String:
					sExpires = `; expires=${vEnd}`;
					break;

				case Date:
					sExpires = `; expires=${(vEnd as Date).toUTCString()}`;
					break;

				default:
					//
			}
		}
		document.cookie = `${encodeURIComponent(sKey)}=${encodeURIComponent(sValue)}${sExpires}${sDomain ? `; domain=${sDomain}` : ""}${sPath ? `; path=${sPath}` : ""}${bSecure ? "; secure" : ""}`;

		return true;
	} catch (error) {
		return false;
	}
}

export function removeItem(sKey: string, sPath?: string, sDomain?: string): boolean {
	try {
		if (!hasItem(sKey)) {
			return false;
		}

		document.cookie = `${encodeURIComponent(sKey)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT${sDomain ? `; domain=${sDomain}` : ""}${sPath ? `; path=${sPath}` : ""}`;

		return true;
	} catch (error) {
		return false;
	}
}

export function keys(): Array<string> {
	// eslint-disable-next-line no-useless-backreference
	const aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);

	for (let nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
		aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
	}

	return aKeys;
}
